import { selectors, isPakOnlyContext } from 'auth/stores/userContext'
import { extractUserContextOverride } from 'utils/routing/routeHelpers'

/**
 * general safety wrapper for any context-getting function
 */
export const withSafeContext = contextGetter => (...args) => {
  try {
    return contextGetter(...args)
  } catch (error) {
    console.error(`Error in context getter: ${error.message}`)
    return null
  }
}

/**
 * Resolves program-scoped user context from Redux state using the same rules as
 * useUserContext: override param, pak-only fallback, and site selection.
 */
export function selectProgramUserContext(state) {
  const userContextOverride = extractUserContextOverride()
  if (userContextOverride) {
    try {
      return JSON.parse(atob(userContextOverride))
    } catch (e) {
      console.warn(
        'Failed to parse base64-encoded userContextOverride',
        userContextOverride,
        'error:',
        e,
      )
    }
  }

  const userContextManager = selectors.selectUserContextManager(state)
  const programContextSelector = isPakOnlyContext(userContextManager)
    ? selectors.selectProgramContext
    : selectors.selectProgramContextWithSiteSelection

  return withSafeContext(programContextSelector)(state)
}
